import React, { useState, useEffect } from 'react';
import { useTheme } from '../../../ThemeContext';
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import './Form360.css';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Breadcrumb from '../../Layouts/Breadcrumb';
import CardContent from '@material-ui/core/CardContent';
import { Card, Button, Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import Authapi from '../../Services/Authapi';
import swal from 'sweetalert';
import ls from 'local-storage';
import { Dialog, DialogTitle, DialogContent, TablePagination } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import AuthCheckComponent from '../../Layouts/Token';
import { Visibility, Delete } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import { withStyles, makeStyles, useTheme as useMuiTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

// Exact same StyledTableRow as TableComponent
const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

// Exact same useStyles as TableComponent
const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  head: {
    backgroundColor: '#1B6E95',
    color: '#fff',
    margin: '0 auto',
    '& th': { color: '#fff' },
    '& th > span:hover': { color: '#fff' },
    '& th:hover': { color: '#fff' },
    '& th:active': { color: '#fff' },
    '& th > span:active': { color: '#fff' },
  },
});

function TablePaginationActions(props) {
  const theme = useMuiTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div style={{ flexShrink: 0, marginLeft: theme.spacing(2.5) }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

export default function Form360(props) {
  const classes = useStyles();

  // if you don't have ThemeContext, you can remove useTheme usage below
  let darkMode = false;
  try {
    const theme = useTheme();
    darkMode = theme?.darkMode || false;
  } catch (e) {
    // ignore if useTheme not provided
    darkMode = false;
  }

  const User = ls("user");
  const userpermissions = (User && Array.isArray(User.roles) && User.roles[0] && Array.isArray(User.roles[0].permissions))
    ? User.roles[0].permissions.map(permissionObj => permissionObj.name)
    : [];

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [currentSection, setCurrentSection] = useState(-1);
  const [responses, setResponses] = useState({});
  const [formDetails, setFormDetails] = useState({});
  const [data, setData] = useState(null);
  const [reviewformlist, setReviewformlist] = useState([]);
  const [reviewformlistdata, setReviewformlistdata] = useState([]);
  const [selectedFormId, setSelectedFormId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [viewMode, setViewMode] = useState(userpermissions.includes("Form360.List") ? 'list' : '');
  const [errors, setErrors] = useState({});
  const [totalSelections, setTotalSelections] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);

  useEffect(() => {
    Reviewformlisttitle();
    Reviewformdynamiclistid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // -----------------------
  // API / Data functions
  // -----------------------
  const Reviewformlisttitle = async () => {
    try {
      let res = await Authapi.Reviewformlist();
      if (res && res.data) setReviewformlist(res.data);
    } catch (error) {
      console.error('Error fetching Reviewformlist:', error);
    }
  };

  const Reviewformdynamiclistid = async () => {
    try {
      const user = ls('user') || {};
      const userid = user.id;
      const role = ls('roles') || ls('role') || null; // attempt both keys
      // If your Authapi exposes different functions, prefer one that exists
      if (role === "Super Admin" && Authapi.Reviewformdynamiclist) {
        const resp = await Authapi.Reviewformdynamiclist(userid);
        if (resp && resp.data) setReviewformlistdata(resp.data);
      } else if (Authapi.Reviewformdynamiclistid) {
        const resp = await Authapi.Reviewformdynamiclistid(userid);
        if (resp && resp.data) setReviewformlistdata(resp.data);
      } else if (Authapi.Reviewformdynamiclist) {
        // fallback if only Reviewformdynamiclist exists
        const resp = await Authapi.Reviewformdynamiclist(userid);
        if (resp && resp.data) setReviewformlistdata(resp.data);
      }
    } catch (error) {
      console.error('Error fetching Reviewformdynamiclistid:', error);
    }
  };

  const fetchFormDetailsById = async (formId) => {
    try {
      const role = await Authapi.ReviewformlistgetformbyID(formId);
      if (role && role.data) {
        setData(role.data);
        // reset section to beginning for new form
        setCurrentSection(-1);
        setErrors({});
        setFormDetails({});
        setResponses({});
      }
    } catch (error) {
      console.error('Error fetching form details:', error);
    }
  };

  // -----------------------
  // Handlers
  // -----------------------
  const handleDetailChange = (label, value) => {
    setFormDetails((prev) => ({ ...prev, [label]: value }));
  };

  const handleResponseChange = (sectionIndex, questionIndex, value, label, type) => {
    setResponses((prevResponses) => {
      const currentSectionResponses = prevResponses[sectionIndex] || {};
      const currentQuestionResponses = currentSectionResponses[label] || "";

      let updatedQuestionResponses;
      if (type === 'checkbox') {
        const selectedOptions = currentQuestionResponses ? currentQuestionResponses.split(',').filter(Boolean) : [];
        if (selectedOptions.includes(value)) {
          updatedQuestionResponses = selectedOptions.filter(item => item !== value).join(',');
        } else {
          updatedQuestionResponses = [...selectedOptions, value].join(',');
        }
      } else {
        updatedQuestionResponses = value;
      }

      // Update totalSelections for radio type (optional)
      if (type === 'radio') {
        // recompute totalSelections
        const newResponses = {
          ...prevResponses,
          [sectionIndex]: {
            ...currentSectionResponses,
            [label]: updatedQuestionResponses
          }
        };
        let count = 0;
        Object.values(newResponses).forEach(section => {
          Object.values(section || {}).forEach(v => {
            if (v && v.toString().trim() !== '') count++;
          });
        });
        setTotalSelections(count);
      }

      return {
        ...prevResponses,
        [sectionIndex]: {
          ...currentSectionResponses,
          [label]: updatedQuestionResponses
        }
      };
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (currentSection === -1 && data?.form_details) {
      data.form_details.forEach(detail => {
        if (detail.type === 'checkbox') {
          const selectedOptions = responses[currentSection]?.[detail.label]?.split(',').filter(Boolean);
          if (!selectedOptions || selectedOptions.length === 0) {
            newErrors[detail.label] = `${detail.label} is required`;
          }
        } else if (!formDetails[detail.label]) {
          newErrors[detail.label] = `${detail.label} is required`;
        }
      });
    } else if (data && data.form_content) {
      const uniqueTitles = Array.from(new Set(data.form_content.map(content => content.title)));
      const currentTitle = uniqueTitles[currentSection];
      if (currentTitle) {
        data.form_content
          .filter(content => content.title === currentTitle)
          .forEach(question => {
            const response = responses[currentSection]?.[question.label];
            if (question.type === 'checkbox') {
              const selectedOptions = response?.split(',').filter(Boolean);
              if (!selectedOptions || selectedOptions.length === 0) {
                newErrors[question.label] = `${question.label} is required`;
              }
            } else if (!response || response.toString().trim() === '') {
              newErrors[question.label] = `${question.label} is required`;
            }
          });
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitted(true);
      setViewMode("list");
    } else {
      console.log("Validation failed", errors);
    }
  };

  const createLeaves = async () => {
    const finalPostData = {
      ...formDetails,
      ...Object.values(responses).reduce((acc, section) => ({ ...acc, ...section }), {})
    };

    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: {
        element: "img",
        attributes: {
          src: "https://www.boasnotas.com/img/loading2.gif",
          style: "width: 50px;"
        }
      }
    });

    try {
      const create = await Authapi.Reviewformdynamicadd(finalPostData, data?.form_name);
      swal.close();
      if (create && create.status === true) {
        setViewMode("list");
        Reviewformdynamiclistid();
        swal("Success", "Form submitted successfully!", "success");
      } else {
        swal("OOPS!", "Something went wrong, please try later!", "error");
      }
    } catch (error) {
      swal.close();
      console.error("Error creating record:", error);
      swal("Error", "Server error while submitting form", "error");
    }
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    if (currentSection === -1) {
      setCurrentSection(0);
    } else if (data && data.form_content) {
      const uniqueTitles = [...new Set(data.form_content.map(item => item.title))];
      if (currentSection < uniqueTitles.length - 1) {
        setCurrentSection(prev => prev + 1);
      } else if (currentSection === uniqueTitles.length - 1) {
        // last section -> create
        await createLeaves();
      }
    }
  };

  const handlePrevious = () => {
    if (currentSection > 0) setCurrentSection(prev => prev - 1);
    else if (currentSection === 0) setCurrentSection(-1);
  };

  const handleFormSelect = (event) => {
    const formId = event.target.value;
    setSelectedFormId(formId);
    fetchFormDetailsById(formId);
  };

  const handleViewClick = (row) => {
    setSelectedData(row);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedData(null);
  };

  const handleViewModeChange = (event) => {
    setViewMode(event.target.value);
    if (event.target.value === "addForm") {
      setIsSubmitted(false);
      resetForm();
    }
  };

  const resetForm = () => {
    setFormDetails({});
    setResponses({});
    setCurrentSection(-1);
    setErrors({});
    setData(null);
    setSelectedFormId(null);
  };

  const handleDeleteClick = async (formId) => {
    swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    }).then(async (confirm) => {
      if (confirm) {
        try {
          const resp = await Authapi.Reviewformdynamicdelete(formId);
          if (resp && resp.status === true) {
            Reviewformdynamiclistid();
            swal("Success", "Form deleted successfully!", "success");
          } else {
            swal("Error", "Unable to delete", "error");
          }
        } catch (err) {
          console.error("Error deleting:", err);
          swal("Error", "Server error while deleting", "error");
        }
      }
    });
  };

  // -----------------------
  // DataGrid columns
  // -----------------------






  return (
    <div className="form360-container">
      <AuthCheckComponent authToken={props.authToken} />
      <Header
        {...props}
        authUser={props.authUser}
        setAutUser={props.setAutUser}
        component={
          <>
            <Card className={classes.card}>
              <CardContent>
                <Breadcrumb {...props}
                  primaryPageName="Feedback Forms"
                  primaryPageLink="/dashboard"
                  isSecondaryPage={false}
                  secondaryPageName="" />
              </CardContent>
            </Card>

            <FormControl variant="outlined" className="form-control" style={{ width: "82%", marginTop: '20px' }}>
              <InputLabel>Choose Action</InputLabel>
              <Select
                onChange={handleViewModeChange}
                value={viewMode || ''}
                className="styled-select"
                label="Choose Action"
              >
                <MenuItem value="" disabled>Select an action</MenuItem>
                <MenuItem value="addForm">Add Form</MenuItem>
                {userpermissions.includes("Form360.List") && <MenuItem value="list">List</MenuItem>}
              </Select>
            </FormControl>

            {viewMode === 'addForm' && (
              <div style={{ marginTop: '62px' }}>
                <FormControl variant="outlined" className="form-control" style={{ width: "82%" }}>
                  <InputLabel>Select a form</InputLabel>
                  <Select
                    onChange={handleFormSelect}
                    value={selectedFormId || ''}
                    className="styled-select"
                    label="Select a form"
                  >
                    <MenuItem value="" disabled>Select a form</MenuItem>
                    {reviewformlist && reviewformlist.map((form) => (
                      <MenuItem key={form.id} value={form.id}>
                        {form.form_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {data && (
                  <div className="form-container" style={{ marginBottom: '80px', marginTop: "45px" }}>
                    <form onSubmit={handleSubmit}>
                      <Typography variant="h4" style={{ color: '#1b6e95', marginBottom: '20px' }}>
                        {data?.form_name}
                      </Typography>

                      {currentSection === -1 && data?.form_details && (
                        <div className={darkMode ? "dark-background" : ""}>
                          <div className="form-row">
                            {data.form_details.map((detail, index) => (
                              <div className="form-group" key={index}>
                                <label style={{ color: '#fbfbfdff' }}>{detail.label}: *</label>

                                {detail.type === 'radio' ? (
                                  <RadioGroup
                                    name={detail.label}
                                    onChange={(e) => handleDetailChange(detail.label, e.target.value)}
                                    className="form-input"
                                    style={{ display: "ruby" }}
                                  >
                                    {detail.options && detail.options.map((option, idx) => (
                                      <FormControlLabel
                                        key={idx}
                                        value={option}
                                        control={<Radio />}
                                        label={option}
                                      />
                                    ))}
                                  </RadioGroup>
                                ) : detail.type === 'checkbox' ? (
                                  <div className="checkbox-group">
                                    {detail.options && detail.options.map((option, idx) => (
                                      <FormControlLabel
                                        key={idx}
                                        style={{ display: "ruby" }}
                                        control={
                                          <Checkbox
                                            checked={responses[currentSection]?.[detail.label]?.split(',').includes(option) || false}
                                            onChange={(e) => handleResponseChange(currentSection, idx, option, detail.label, 'checkbox')}
                                          />
                                        }
                                        label={option}
                                      />
                                    ))}
                                  </div>
                                ) : (
                                  <input
                                    type={detail.type}
                                    name={detail.label}
                                    required
                                    onChange={(e) => handleDetailChange(detail.label, e.target.value)}
                                    className="form-input"
                                  />
                                )}

                                {errors[detail.label] && <span className="error" style={{ color: 'red' }}>{errors[detail.label]}</span>}
                              </div>
                            ))}
                          </div>
                          <div className="form-group">
                            <Button variant="contained" color="primary" onClick={handleNext} style={{ textTransform: 'capitalize' }}>
                              Next
                            </Button>
                          </div>
                        </div>
                      )}

                      {/* Feedback Sections */}
                      {currentSection >= 0 &&
                        data?.form_content &&
                        currentSection < Array.from(new Set(data.form_content.map(content => content.title))).length && (
                          <>
                            <div className="progress-indicator">
                              {Array.from(new Set(data.form_content.map(content => content.title))).map((title, index) => (
                                <div
                                  key={index}
                                  className={`progress-step ${index === currentSection ? 'active' : ''}`}
                                  onClick={() => setCurrentSection(index)}
                                >
                                  <span className="step-number">{index + 1}</span>
                                  <span className="step-title">{title}</span>
                                </div>
                              ))}
                            </div>


                            <div className={`form-section ${darkMode ? "dark-background" : ""}`}>

                              <Typography
                                variant="h5"
                                style={{
                                  color: darkMode ? '#ffffff' : '#1b6e95',
                                  marginBottom: '10px'
                                }}
                              >
                                {Array.from(new Set(data.form_content.map(content => content.title)))[currentSection]}
                              </Typography>

                              <table className="table">
                                <tbody>
                                  {data.form_content
                                    .filter(
                                      content =>
                                        content.title ===
                                        Array.from(new Set(data.form_content.map(content => content.title)))[currentSection]
                                    )
                                    .map((question, index) => (
                                      <React.Fragment key={index}>
                                        <div style={{ marginBottom: '20px' }}>
                                          <Typography
                                            variant="h6"
                                            style={{
                                              textAlign: "justify",
                                              marginBottom: '8px',
                                              color: darkMode ? "#ffffff" : "#000000"
                                            }}
                                          >
                                            {question.label}
                                          </Typography>

                                          {question.type === 'checkbox' ? (
                                            question.options &&
                                            question.options.map((option, idx) => (
                                              <FormControlLabel
                                                key={idx}
                                                control={
                                                  <Checkbox
                                                    checked={
                                                      responses[currentSection]?.[question.label]?.split(',').includes(option) ||
                                                      false
                                                    }
                                                    onChange={(e) =>
                                                      handleResponseChange(currentSection, index, option, question.label, 'checkbox')
                                                    }
                                                  />
                                                }
                                                label={option}
                                                style={{ marginRight: '16px', color: darkMode ? "#ffffff" : "#000000" }}
                                              />
                                            ))
                                          ) : question.type === 'radio' ? (
                                            <RadioGroup
                                              row
                                              name={`question-${currentSection}-${index}`}
                                              value={responses[currentSection]?.[question.label] || ""}
                                              onChange={(e) =>
                                                handleResponseChange(currentSection, index, e.target.value, question.label, 'radio')
                                              }
                                            >
                                              {question.options &&
                                                question.options.map((option, idx) => (
                                                  <FormControlLabel
                                                    key={idx}
                                                    value={option ? option.toString() : ""}
                                                    control={<Radio />}
                                                    label={option}
                                                    style={{ marginRight: '16px', color: darkMode ? "#ffffff" : "#000000" }}
                                                  />
                                                ))}
                                            </RadioGroup>
                                          ) : (
                                            <input
                                              type={question.type}
                                              name={question.label}
                                              value={responses[currentSection]?.[question.label] || ""}
                                              onChange={(e) =>
                                                handleResponseChange(currentSection, index, e.target.value, question.label, question.type)
                                              }
                                              className="form-input"
                                              style={{
                                                width: '100%',
                                                padding: '10px',
                                                borderRadius: '4px',
                                                border: '1px solid #ccc',
                                                boxSizing: 'border-box',
                                                marginBottom: '10px',
                                                background: darkMode ? "#2c2c2c" : "#ffffff",
                                                color: darkMode ? "#ffffff" : "#000000"
                                              }}
                                            />
                                          )}
                                        </div>

                                        {errors[question.label] && (
                                          <span className="error" style={{ color: 'red' }}>
                                            {errors[question.label]}
                                          </span>
                                        )}
                                        <br />
                                        <br />
                                      </React.Fragment>
                                    ))}
                                </tbody>
                              </table>

                              <div className="form-navigation">
                                {currentSection > 0 && (
                                  <Button variant="contained" onClick={handlePrevious} style={{ textTransform: 'capitalize' }}>
                                    Previous
                                  </Button>
                                )}
                                <Button variant="contained" color="primary" onClick={handleNext} style={{ textTransform: 'capitalize' }}>
                                  Next
                                </Button>
                              </div>
                            </div>
                          </>
                        )}

                      {/* Thank You Section */}
                      {data && currentSection === Array.from(new Set(data.form_content ? data.form_content.map(content => content.title) : [])).length && (
                        <div>
                          <Typography variant="h4" style={{ color: '#4caf50' }}>
                            Thank you for your submission!
                          </Typography>
                        </div>
                      )}
                    </form>
                  </div>
                )}
              </div>
            )}

            {viewMode === 'list' && (
              <div style={{ marginBottom: '80px', marginTop: '62px' }}>
                <Paper style={{ width: '98%', margin: '0 auto', overflow: 'hidden' }}>
                  <TableContainer style={{ maxHeight: '100%', overflowX: 'auto' }}>
                    <Table className={classes.table} aria-label="form 360 list" style={{ tableLayout: 'auto', minWidth: '100%' }}>
                      <TableHead>
                        <TableRow className={classes.head}>
                          <TableCell style={{ color: '#fff', fontWeight: 600 }}>Form Title</TableCell>
                          <TableCell style={{ color: '#fff', fontWeight: 600 }}>User Name</TableCell>
                          <TableCell style={{ color: '#fff', fontWeight: 600 }}>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(reviewformlistdata || []).length === 0 ? (
                          <StyledTableRow>
                            <TableCell colSpan={3} align="center" style={{ fontWeight: 'bold', color: darkMode ? '#fff' : 'inherit', backgroundColor: darkMode ? '#1e1e1e' : 'inherit' }}>
                              No rows found
                            </TableCell>
                          </StyledTableRow>
                        ) : (
                          (reviewformlistdata || [])
                            .slice(page * pageSize, page * pageSize + pageSize)
                            .map((row) => (
                              <StyledTableRow key={row.id}>
                                <TableCell align="left">{row.form_name}</TableCell>
                                <TableCell align="left">{row.first_name}</TableCell>
                                <TableCell align="left">
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <IconButton size="small" color="primary" onClick={() => handleViewClick(row)}>
                                      <Visibility fontSize="small" />
                                    </IconButton>
                                    <IconButton size="small" color="primary" onClick={() => handleDeleteClick(row.id)}>
                                      <Delete fontSize="small" />
                                    </IconButton>
                                  </div>
                                </TableCell>
                              </StyledTableRow>
                            ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <TablePagination
                    component="div"
                    count={(reviewformlistdata || []).length}
                    page={page}
                    onPageChange={(event, newPage) => setPage(newPage)}
                    rowsPerPage={pageSize}
                    onRowsPerPageChange={(event) => {
                      setPageSize(parseInt(event.target.value, 10));
                      setPage(0);
                    }}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    style={{ color: darkMode ? '#ffffff' : 'inherit', borderBottom: 'none', width: 'fit-content' }}
                    ActionsComponent={TablePaginationActions}
                  />
                </div>

                <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm">
                  <DialogTitle
                    style={{
                      textAlign: "center",
                      padding: "5px 0",
                      backgroundColor: "#1b6e95",
                      color: "#fff",
                      position: "relative"
                    }}
                  >
                    Form Details
                    <CloseIcon
                      style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        cursor: "pointer",
                        color: "#fff",
                        backgroundColor: "#f44336",
                        borderRadius: "50%",
                        padding: "2px",
                      }}
                      onClick={handleCloseDialog}
                    />
                  </DialogTitle>
                  <DialogContent style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    {selectedData && (
                      <div>
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', marginBottom: '10px' }}>
                          <div>
                            <strong>Form Name:</strong> {selectedData.form_name}
                          </div>
                          <div>
                            <strong>User ID:</strong> {selectedData.user_id}
                          </div>
                        </div>
                        {selectedData.data && (
                          <div>
                            {Object.entries(selectedData.data).map(([sectionTitle, sectionData]) => (
                              <div key={sectionTitle} style={{ marginBottom: '15px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}>
                                <h5 style={{ marginBottom: '10px' }}>{sectionTitle.replace(/_/g, ' ')}</h5>
                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                  {Object.entries(sectionData).map(([key, value]) => (
                                    <div key={key} style={{ marginBottom: '10px', marginRight: '10px', flex: '1 1 45%' }}>
                                      <strong>{key.replace(/_/g, ' ')}:</strong>
                                      {Array.isArray(value) ? (
                                        value.map((option, idx) => (
                                          <FormControlLabel
                                            key={idx}
                                            control={<Checkbox checked={true} disabled />}
                                            label={option}
                                          />
                                        ))
                                      ) : typeof value === 'boolean' ? (
                                        <FormControlLabel
                                          control={<Checkbox checked={value} disabled />}
                                          label={key.replace(/_/g, ' ')}
                                        />
                                      ) : (
                                        <input
                                          type={typeof value === 'number' ? 'number' : 'text'}
                                          value={typeof value === 'object' ? JSON.stringify(value) : value}
                                          disabled
                                          style={{
                                            width: '100%',
                                            padding: '6px',
                                            borderRadius: '4px',
                                            border: '1px solid #ccc',
                                            marginTop: '5px'
                                          }}
                                        />
                                      )}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </DialogContent>
                </Dialog>
              </div>
            )}
          </>
        }
      />
      <Footer {...props} />
    </div>
  );
}
